import {
  absolutePathPoints,
  measureLabel,
  smoothPath,
} from "./drawingAnnotationUtils";

export const DrawingMeasureShape = ({
  x1,
  y1,
  x2,
  y2,
  color,
  strokeWidth = 2.5,
  draft = false,
  measureScale,
}) => {
  const tick = 7;
  const angle = Math.atan2(y2 - y1, x2 - x1);
  const tdx = tick * Math.cos(angle + Math.PI / 2);
  const tdy = tick * Math.sin(angle + Math.PI / 2);
  const mx = (x1 + x2) / 2;
  const my = (y1 + y2) / 2;
  const label = measureLabel(x1, y1, x2, y2, measureScale);
  const labelWidth = label.length * 7.5 + 18;

  return (
    <g opacity={draft ? 0.95 : 1}>
      <line
        x1={x1}
        y1={y1}
        x2={x2}
        y2={y2}
        stroke={color}
        strokeWidth={Math.max(1.4, strokeWidth)}
      />
      <line
        x1={x1 - tdx}
        y1={y1 - tdy}
        x2={x1 + tdx}
        y2={y1 + tdy}
        stroke={color}
        strokeWidth={Math.max(1.4, strokeWidth)}
      />
      <line
        x1={x2 - tdx}
        y1={y2 - tdy}
        x2={x2 + tdx}
        y2={y2 + tdy}
        stroke={color}
        strokeWidth={Math.max(1.4, strokeWidth)}
      />
      <rect
        x={mx - labelWidth / 2}
        y={my - 13}
        width={labelWidth}
        height={20}
        rx={4}
        fill="#fff"
        stroke={color}
        strokeWidth={1.2}
      />
      <text
        x={mx}
        y={my + 2}
        fill={color}
        fontFamily="ui-monospace, monospace"
        fontSize={12}
        fontWeight={600}
        textAnchor="middle"
      >
        {label} mm
      </text>
    </g>
  );
};

export const DrawingPenShape = ({
  points,
  color,
  strokeWidth = 2.5,
  draft = false,
}) => (
  <path
    d={smoothPath(points)}
    stroke={color}
    strokeWidth={strokeWidth}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    opacity={draft ? 0.95 : 1}
  />
);

export const DrawingAnnotationLayer = ({
  modules,
  draftPen,
  draftMeasure,
  strokeWidth,
  measureScale,
}) => {
  return (
    <svg
      className="pointer-events-none absolute inset-0 overflow-visible"
      width="100%"
      height="100%"
    >
      {modules
        .filter(
          (module) =>
            module.module_type === "pen" || module.module_type === "measure"
        )
        .map((module) => {
          if (module.module_type === "pen") {
            return (
              <DrawingPenShape
                key={module.id}
                points={absolutePathPoints(module)}
                color={module.color || "#14171c"}
                strokeWidth={parseFloat(module.width) || strokeWidth}
              />
            );
          }

          return (
            <DrawingMeasureShape
              key={module.id}
              x1={parseFloat(module.x_position) || 0}
              y1={parseFloat(module.y_position) || 0}
              x2={parseFloat(module.x2_position) || 0}
              y2={parseFloat(module.y2_position) || 0}
              color={module.color || "#2ea66b"}
              strokeWidth={parseFloat(module.width) || strokeWidth}
              measureScale={measureScale}
            />
          );
        })}
      {draftPen?.points?.length > 1 && (
        <DrawingPenShape
          points={draftPen.points}
          color={draftPen.color}
          strokeWidth={draftPen.width || strokeWidth}
          draft
        />
      )}
      {draftMeasure && (
        <DrawingMeasureShape
          x1={draftMeasure.x1}
          y1={draftMeasure.y1}
          x2={draftMeasure.x2}
          y2={draftMeasure.y2}
          color={draftMeasure.color}
          strokeWidth={draftMeasure.width || strokeWidth}
          draft
          measureScale={measureScale}
        />
      )}
    </svg>
  );
};
